import {createSlice} from "@reduxjs/toolkit";

const initialScholarEducationsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  scholarEducationForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const scholarEducationsSlice = createSlice({
  name: "scholarEducations",
  initialState: initialScholarEducationsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getScholarEducationById
    scholarEducationFetched: (state, action) => {
      state.actionsLoading = false;
      state.scholarEducationForEdit = action.payload.scholarEducationForEdit;
      state.error = null;
    },
    // findScholarEducations
    scholarEducationsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createScholarEducation
    scholarEducationCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.scholarEducation);
    },
    // updateScholarEducation
    scholarEducationUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schEducationId === action.payload.scholarEducation.schEducationId) {
          return action.payload.scholarEducation;
        }
        return entity;
      });
    },
    // deleteScholarEducation
    scholarEducationDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schEducationId !== action.payload.schEducationId);
    },
    // deleteScholarEducations
    scholarEducationsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schEducationId)
      );
    },
  }
});
